<div class="add-collaborators-container">
  <!-- Header -->
  <div class="header row space-btw ai-c">
    <h1 class="title">Invite Collaborators</h1>
    <div class="close-btn flex ai-c ha-c" (click)="close()">
      <mat-icon>close</mat-icon>
    </div>
  </div>

  <!-- Content -->
  <div class="content col">
    <!-- Tab Group -->
    <div class="tab-group row ai-c ha-c">
      <div class="tab-item" [class.active]="selectedTab === 'internal'" (click)="switchTab('internal')">
        Internal
      </div>
      <div class="tab-item" [class.active]="selectedTab === 'guest'" (click)="switchTab('guest')">
        Guest
      </div>
    </div>

    <!-- Fields Section -->
    <div class="fields-section col">
      <!-- Search Bar -->
      <div class="search-bar row ai-c">
        <div class="search-icon flex ai-c ha-c">
          <mat-icon>search</mat-icon>
        </div>
        <input type="text" 
               [formControl]="searchControl" 
               placeholder="Search for Collaborators"
               class="search-input">
      </div>

      <!-- Select All -->
      <div class="select-all-row row space-btw ai-c">
        <span class="select-all-text" (click)="toggleSelectAll()">Select All</span>
      </div>

      <!-- Collaborators List -->
      <div #collaboratorsListContainer class="collaborators-list col">
        <div class="collaborator-row row space-btw ai-c" *ngFor="let collab of collaboratorsList; trackBy: trackByUserId">
          <!-- Left: Checkbox + Avatar + Info -->
          <div class="collaborator-info row ai-c">
            <div class="checkbox-wrapper row ai-c">
              <input type="checkbox"
                     class="hmt-checkbox"
                     [checked]="isSelected(collab.user.id)"
                     (change)="toggleCollaborator(collab)"
                     [id]="'collab-' + collab.user.id">
            </div>
            <div class="avatar flex ai-c ha-c" [style.background-color]="collab.user.avatarColor || '#45317C'">
              <img *ngIf="getPhotoUrl(collab.user.photo)" [src]="getPhotoUrl(collab.user.photo)" alt="User photo">
              <img *ngIf="!getPhotoUrl(collab.user.photo) && collab.user.profilePicture" [src]="collab.user.profilePicture" alt="">
              <span *ngIf="!getPhotoUrl(collab.user.photo) && !collab.user.profilePicture">{{ collab.user.firstName?.charAt(0) }}</span>
            </div>
            <div class="user-details col">
              <div class="user-name">{{ collab.user.firstName }} {{ collab.user.lastName }}</div>
              <div class="user-role">{{ collab.user.roleName || 'User' }}</div>
            </div>
          </div>

          <!-- Right: Permission Dropdown (only for selected) -->
          <div class="permission-dropdown" *ngIf="isSelected(collab.user.id)">
            <button class="permission-btn row ai-c ha-c" [matMenuTriggerFor]="permissionMenu">
              <span class="permission-text">{{ collab.permission === 'view' ? 'View' : 'Editor' }}</span>
              <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
            </button>
            <mat-menu #permissionMenu="matMenu" class="permission-menu">
              <button mat-menu-item (click)="changePermission(collab, 'view')">View</button>
              <button mat-menu-item (click)="changePermission(collab, 'editor')">Editor</button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer row space-btw ai-c">
    <div class="selected-summary row ai-c">
      <span class="selected-names">{{ selectedNames }}</span>
      <div class="count-badge flex ai-c ha-c" *ngIf="remainingCount > 0">
        +{{ remainingCount }}
      </div>
    </div>
    <button class="hmt-action-button invite-btn"
            [disabled]="selectedCount === 0"
            (click)="invite()">
      Invite
    </button>
  </div>
</div>

